const data=[
    {
        id:0,
        title:"BLOGSPOT(MERN)",
        img:"https://images.pexels.com/photos/3584994/pexels-photo-3584994.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
        descriptiom:"This project showcases React, Styled Components, NodeJs, and MongoDB database delivering a seamless blend of modern design, functionality, and responsiveness.",
        gitLink:'https://github.com/adityaPawar1999/blogspot',
        siteLink:'Error',
    },
    {
        id:1,
        title:"NoteCare",
        img:"https://images.unsplash.com/photo-1522542550221-31fd19575a2d?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        descriptiom:"Notecare is a versatile note-taking web application built with React, featuring user authentication, CRUD operations on notes, search functionality, and customizable note colors.",
        gitLink:"https://github.com/adityaPawar1999/notecareWebApp",
        siteLink:"Error",
    },{
        id:2,
        title:"WEATHER WEBAPP",
        img:"https://images.unsplash.com/photo-1614480633894-f3b7f4bb0e76?q=80&w=1887&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        descriptiom:"Powerful weather application accessible directly from your web browser, delivering accurate and detailed weather forecasts right to your desktop.",
        gitLink:'https://github.com/adityaPawar1999/Weather-App',
        siteLink:"error"
    },{
        id:3,
        title:"UPDATEDAILY WEBSITE UI",
        img:"https://images.unsplash.com/photo-1518975775530-f4dcbbee9672?q=80&w=1696&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        descriptiom:"Explore bloghub , a React project where I've crafted a vibrant blog website using styled components. Enjoy a visually stunning and user-friendly....",
        gitLink:"https://github.com/adityaPawar1999/bloghub",
        siteLink:" https://peaceful-peony-86715b.netlify.app/",

    },{
        id:4,
        title:"TODO APP (mern) ",
        img:"https://images.unsplash.com/photo-1484480974693-6ca0a78fb36b?q=80&w=2072&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        descriptiom:"A Full MERN (MongoDB, Express.js, React, Node.js) Todo application represents a powerful and versatile tool for task management.",
        gitLink:"https://github.com/adityaPawar1999/TODOAPP",
        siteLink:"Error",
    },{
        id:5,
        title:"SpotifyUI",
        img:" https://images.unsplash.com/photo-1614680376593-902f74cf0d41?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8c3BvdGlmeXxlbnwwfHwwfHx8MA%3D%3D",
        descriptiom:"SpotifyWeb: Frontend React project for exploring Spotify's music library, creating playlists, and enjoying seamless playback experiences",
        gitLink:"https://github.com/adityaPawar1999/SpotifyUI",
        siteLink:"Error",
    },
   
];


const miniData = [
    {
        id: 1,
        title: "Login Page UI",
        descr: "ReactJS ,Styled-Component ,Bootstrap ,Material-UI",
        link:'https://github.com/adityaPawar1999/loginpage',

    },
    {
        id: 2,
        title: "Product Showcase Web App Assignment",
        descr: "html5,css3, javascript ", 
        link:"https://github.com/adityaPawar1999/Assignment-For-Marmeto"
    },
    {
        id: 3,
        title: "Body Mass Index Calculator",
        descr: "html5,css3, javascript,", 
        link:"https://github.com/adityaPawar1999/Body-Mass-Index-Web-Application-Html-css-javascript"
    },
    {
        id: 4,
        title: "RestFul API with Authentication ",
        descr: "NodeJS ,ExpressJs, MongoDB, Postman,", 
        link:"https://github.com/adityaPawar1999/RestFulApi"
    },
    {
        id: 5,
        title: "Multi Step Form ",
        descr: "react js , tailwind css", 
        link:"https://github.com/adityaPawar1999/MultiStepForm"
    },
];

export { data, miniData };
